/**
 ################################

 ################################
 */


'use strict';

jQuery(document).ready(function ($) {
    var headerHeight = $('#geeg_navbar').innerHeight();
    //var components = $('.geeg_sticky_offset');

    var divs = document.querySelectorAll('div.geeg_sticky_offset');
     [].forEach.call(divs, function (div) {
        // do whatever
        div.style["top"] = headerHeight+'px';
        div.style["z-index"] = '999';
    });


    $(document).on('carbonFields.apiLoaded', function(e, api) {
        // Get the current value in the 'crb_text' field
        var value = api.getFieldValue( 'header_type' );
        console.log(value)
    });

//console.log(divs);
});

